import { render, staticRenderFns } from "./ActionMealDislike.vue?vue&type=template&id=75e3e322&scoped=true"
import script from "./ActionMealDislike.vue?vue&type=script&lang=js"
export * from "./ActionMealDislike.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e3e322",
  null
  
)

export default component.exports